import type { DocCollection } from '@blocksuite/store';
import type { WorkspaceFlavour } from '@pique/env/workspace';

import { Service } from '../../../framework';
import type { BlobStorage, DocStorage } from '../../../sync';
import type { WorkspaceFlavourProvider } from '../providers/flavour';

export class WorkspaceFactoryService extends Service {
  constructor(private readonly providers: WorkspaceFlavourProvider[]) {
    super();
  }

  create = async (
    flavour: WorkspaceFlavour,
    customize?: (
      docCollection: DocCollection,
      blobStorage: BlobStorage,
      docStorage: DocStorage
    ) => Promise<void>
  ) => {
    const provider = this.providers.find(x => x.flavour === flavour);
    if (!provider) {
      throw new Error(`Unknown workspace flavour: ${flavour}`);
    }
    const metadata = await provider.createWorkspace(
      async (docCollection, blobStorage, docStorage) => {
        docCollection.meta.initialize();
        docCollection.meta.setName('Default');
        if (customize) {
          await customize(docCollection, blobStorage, docStorage);
        }
      }
    );
    return metadata;
  };
}
